var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TextField as MuiTextField, FormControlLabel, Radio, Box, Stack, } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { format, add, isBefore } from 'date-fns';
import { getCurrentUser } from '../../localStorage';
var translateScope = 'pages.deliveryRequestItemsAndRequestDateForm.captions.datePicker';
var DeliveryRequestDatePicker = function (_a) {
    var roaster = _a.roaster, deliveryRequestGroupItemsAndRequestDate = _a.deliveryRequestGroupItemsAndRequestDate, value = _a.value, _b = _a.fastestSelectable, fastestSelectable = _b === void 0 ? true : _b, onChange = _a.onChange, dialogProps = _a.dialogProps;
    var t = useTranslation().t;
    var minDate = add(new Date(), {
        days: (roaster.isOfficeEurope ? 14 : 7) + 1,
    });
    var createdAtOrCurrent = (deliveryRequestGroupItemsAndRequestDate === null || deliveryRequestGroupItemsAndRequestDate === void 0 ? void 0 : deliveryRequestGroupItemsAndRequestDate.createdAt)
        ? new Date(deliveryRequestGroupItemsAndRequestDate === null || deliveryRequestGroupItemsAndRequestDate === void 0 ? void 0 : deliveryRequestGroupItemsAndRequestDate.createdAt)
        : new Date();
    var selectableWithinMonths = getCurrentUser().role === 'admin' ? 10 : 5;
    var maxDate = add(createdAtOrCurrent, {
        months: selectableWithinMonths,
        days: 1,
    });
    if (isBefore(maxDate, minDate))
        maxDate = minDate;
    var _c = React.useState(true), fastestDelivery = _c[0], setFastestDelivery = _c[1];
    var mainCaption = React.useMemo(function () {
        var startWeekKey = roaster.isOfficeEurope ? 'startWeek2' : 'startWeek1';
        var startWeek = t("".concat(translateScope, ".main.").concat(startWeekKey));
        return t("".concat(translateScope, ".main.deliveryDateExplanation"), { startWeek: startWeek });
    }, [t, roaster.isOfficeEurope]);
    var subCaption = React.useMemo(function () {
        return t("".concat(translateScope, ".sub.").concat(roaster.isOfficeEurope ? 'europe' : 'etc'));
    }, [t, roaster.isOfficeEurope]);
    React.useEffect(function () {
        setFastestDelivery(fastestSelectable && !value);
    }, [fastestSelectable, value]);
    var handleChangeShortestRadio = React.useCallback(function (event, checked) {
        if (checked) {
            setFastestDelivery(true);
            onChange(null, true);
        }
    }, [onChange]);
    var handleChangeSelectDateRadio = React.useCallback(function (event, checked) {
        if (checked) {
            setFastestDelivery(false);
            onChange(null, false);
        }
    }, [onChange]);
    var isWeekendOrWarehouseHoliday = React.useCallback(function (date) {
        var day = date.getDay();
        if (day === 0 || day === 6)
            return true;
        var warehouseHolidays = roaster.country.warehouses
            .map(function (warehouse) { return warehouse.holidays; })
            .flat();
        return warehouseHolidays.some(function (warehouseHoliday) {
            if (!warehouseHoliday)
                return false;
            var holiday = new Date(warehouseHoliday.date);
            holiday.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);
            return date.getTime() === holiday.getTime();
        });
    }, [roaster.country.warehouses]);
    var datePicker = React.useMemo(function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { ml: 4 },
                React.createElement(MobileDatePicker, { label: t('labels.deliveryRequestFormRequestDate'), inputFormat: "yyyy-MM-dd", value: value ? new Date(value) : null, minDate: minDate, maxDate: maxDate, onChange: function (value) {
                        if (!value)
                            return;
                        var date = value;
                        var dateFormat = 'yyyy-MM-dd';
                        onChange(date ? format(date, dateFormat) : '', false);
                    }, renderInput: function (inputProps) {
                        return React.createElement(MuiTextField, __assign({}, inputProps));
                    }, DialogProps: dialogProps, showToolbar: false, shouldDisableDate: isWeekendOrWarehouseHoliday })),
            React.createElement(Stack, { mt: 2 },
                React.createElement(Typography, { variant: "caption" }, mainCaption),
                React.createElement(Typography, { variant: "caption" }, subCaption))));
    }, [
        value,
        dialogProps,
        mainCaption,
        maxDate,
        minDate,
        onChange,
        subCaption,
        t,
        isWeekendOrWarehouseHoliday,
    ]);
    if (!fastestSelectable) {
        return datePicker;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { spacing: 1 },
            React.createElement(FormControlLabel, { control: React.createElement(Radio, { onChange: handleChangeShortestRadio, checked: fastestDelivery, color: "success", sx: { padding: '0 8px 0 0' } }), label: t('labels.fastestDeliveryRequest'), sx: { m: 0 } }),
            React.createElement(FormControlLabel, { control: React.createElement(Radio, { onChange: handleChangeSelectDateRadio, checked: !fastestDelivery, color: "success", sx: { padding: '0 8px 0 0' } }), label: t('labels.deliveryRequestByDate') })),
        fastestDelivery && (React.createElement(Box, { mt: 2 },
            React.createElement(Typography, { variant: "caption" }, t("".concat(translateScope, ".fastestDelivery"))))),
        !fastestDelivery && React.createElement(Box, { mt: 1 }, datePicker)));
};
export default DeliveryRequestDatePicker;
